import {getVaccin, pushConfirmAxios, downExcelAxios, addressList, apiHttp, isEmail, isPhone, isHKPhone, emailNotice, getVerifyCode} from "../../js/axios";
import el from "element-ui/src/locale/lang/el";
import axios from 'axios'  //这里引入axios  mian无需再引
import Vue from "vue";    //引入Vue
Vue.prototype.$ajax = axios;  //修改ajax原型指向为 axios
import Qs from 'qs';
export default {
    name: 'vaccin',
    data() {
        return {
            phone: false,
            yzCode: false,
            ifEdit: false,
            dateValue: '',
            pickerBeginDateBefore: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                },
            },
            tableData: [],
            multipleSelection: [],
            pageCount: 1,
            pageNum: 0,
            areaBookinglist: [
				{id: 0, name: "全部"},
                {id: 1, name: "智䝨综合医疗中心-康健联营诊所"},
                {id: 2, name: "中卓医务综合专科医疗中心"},
                {id: 3, name: "香港体检-佐敦旗艦店"},
                {id: 4, name: "瑞康医疗中心"},
                {id: 5, name: "韦予力医生医务所(尖沙咀)"},
                {id: 6, name: "康健-基健医务中心"},
                {id: 7, name: "康健-基健綜合医务中心"},
                {id: 8, name: "康健医务中心"}
            ],
            areaValue: '',
			areaValueChange: false,
            dateEdit: '',
			dateEditChange: false,
            timeEdit: '',
			timeEditChange: false,
            editAreaID: 0,

            createdTimeW: 0,
            usernameW: 0,
            finishW: 0,
            phoneW: 0,
            user_idW: 0,
            packageW: 0,

            pickerOptions: {
                disabledDate(time) {
                    let _now = Date.now(),
                        min = 3 * 24 * 60 * 60 * 1000,
                        max = 14 * 24 * 60 * 60 * 1000,
                        minDays = _now + min,
                        maxDays = _now + max;

                    return time.getTime() < minDays || time.getTime() > maxDays;
                    //大于当前的禁止，小于7天前的禁止
                }
            },

            options: [{
                value: '0',
                label: '全部'
            }, {
                value: '1',
                label: '已預約'
            }, {
                value: '2',
                label: '已完成'
            }, {
                value: '90',
                label: '已過期'
            }],
			statusList: [{
				label: '0',
				value: '全部',
			},{
				label: '1',
				value: '已预约',
			},
			{
				label: '80',
				value: '已接种',
			},
			{
				label: '71',
				value: '已退款',
			},
			{
				label: '90',
				value: '已取消',
			}],
            value: '',
			appt_status: '0',
            http: apiHttp() + '/v3/back/export/',
            showDate: '',
            tipStatus: "",
            tipText: "",
            alertShow: false,

			downFile:false,
			
			emailNotice: false ,// 设置系统通知
			emailNoticeVal: [
				{ value: '' }
			],//邮箱地址
			emailNoticeTel: '',//手机号
			oldEmailNoticeTel: '',//已有手机号,用来检查是否修改过手机号
			telArea: '852',//手机区号 默认香港852
			emailNoticeCode: '',//验证码
			codeSending: false,//是否正在发送验证码
			countDown: 60//倒计时秒数
        }
    },

    mounted() {

        this.resizeChange();
        window.onresize = () => {
            return (() => {
                this.resizeChange()
            })();
        };
        let minDate = new Date();
        minDate.setDate(minDate.getDate() + 4);
        this.showDate = minDate;

		this.getReport()
        // addressList().then(res => {
        //     if (res.status == '1') {
        //         res.data.forEach(item => {
        //             item.name = item.name + "：" + item.address
        //         })
        //         this.areaBookinglist = res.data;
        //     }
        // })

    },
    methods: {
		resetPage(){
			this.pageCount = 1
			this.pageNum = 1
		},
        confirmDialog() {
            this.alertShow = false;
        },
        closeDialog() {
            this.alertShow = false;
            //把绑定的弹窗数组 设为false即可关闭弹窗
        },

        dateChange(time) {
			this.dateEditChange = true;
			
            let week = new Date(time);
            if (week.getDay() == '0') {

                this.alertShow = true;
                this.tipStatus = "查詢失敗";
                this.tipText = "請選擇週日以外的日期";
            }
        },
        resizeChange() {
            let tableWidth = document.getElementsByClassName('el-table__body-wrapper')[0].offsetWidth;
        },

        handleCurrentChange(val) {
            this.pageNum = val;
            this.reportCommit(val);
        },
        reportCommit(val) {
			let data = {
			    startat: this.dateValue ? this.dateValue[0] / 1000 : '',
			    endat: this.dateValue ?  this.dateValue[1] / 1000 : '',
			    appt_status: this.appt_status,
			    page: val,
			    pagesize: 10
			};
			
			getVaccin(data).then((res) => {
			    if (res.code == 200) {
			        if (res.data.data != '') {
			            this.pageCount = parseInt(res.data.pager.count);
			            
			
			            this.tableData = res.data.data;
						
			
			            this.downFile = true;
			        } else {
						this.pageCount = 1;
			            // this.alertShow = true;
			            // this.tipStatus = "查詢結果";
			            // this.tipText = "暂无数据";
			            this.tableData = res.data.data;
			
			            this.downFile = false;
			        }
			
			    } else {
					this.resetPage()
					this.alertShow = true;
					this.tipStatus = "查詢失敗";
					this.tipText = res.msg;
				}
			})
        },
        closeEdit() {
            this.ifEdit = false;
            this.areaValue = '';
            this.dateEdit = '';
            this.timeEdit = '';
            this.editAreaID = 0;

        },
        getReport() {
            this.reportCommit(1);
        },
		handleReset() {
			this.dateValue = '';
			this.appt_status = '0';
            this.reportCommit(1);
		},
		downExcel() {
			if(this.tableData.length <= 0) {
				
				this.alertShow = true;
				this.tipStatus = "下载失败";
				this.tipText = "请选择要导出的数据";
			}else {
		        this.$refs.down.click();
		
		    }
		}
    }
}